import { createFileRoute } from "@tanstack/react-router";
import { actions } from "../../lib/actions.ts";
import { InsightsScreen, type InsightsTab } from "../../screens/insights/InsightsScreen.tsx";

type Search = { show?: Exclude<InsightsTab, "open"> };

/** `/insights`: what Adea found, the open ones by how much they matter; `?show=` mine, snoozed or done. */
export const Route = createFileRoute("/_app/insights/")({
  validateSearch: (s: Record<string, unknown>): Search =>
    s.show === "mine" || s.show === "snoozed" || s.show === "done" ? { show: s.show } : {},
  loader: ({ context }) =>
    context.queryClient.prefetchQuery(actions.queryOptions("insights.list", { show: "open" })),
  component: InsightsScreen,
});
